import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	Row,
	Card,
	CardHeader,
	CardBody,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getNormativeList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditNormativeModal from './Add_Edit/AddEditNormativeModal';
import DeleteNormativeModal from './Delete/DeleteNormative';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import AddEditArticleModal from './Add_Edit/AddEditArticleModal';
import AddEditBCNModal from './Add_Edit/AddEditBCNModal';
import { toSmartTitleCase } from '../../../utils/toSmartTitleCase';

const NormativesList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorNormatives = createSelector(
		state => state.Normatives,
		normative => ({
			normativeList: normative.normativeList,
			isLoadingList: normative.isLoadingList,
			isNormativeSuccess: normative.isNormativeSuccess,
			error: normative.error,
			isAdding: normative.isAdding,
			isAdded: normative.isAdded,
			isAddError: normative.isAddError,
			isUpdating: normative.isUpdating,
			isUpdated: normative.isUpdated,
			isUpdateError: normative.isUpdateError,
			isDeleting: normative.isDeleting,
			isDeleted: normative.isDeleted,
			isDeleteError: normative.isDeleteError,
		})
	);

	const { normativeList, isLoadingList } = useSelector(selectorNormatives);

	useEffect(() => {
		dispatch(getNormativeList());
	}, []);

	const [dataNormative, setDataNormative] = useState({});
	const [bcn_code, setBCNCode] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	const [modal, setModal] = useState(false);
	const [modalArticle, setModalArticle] = useState(false);
	const [modalBCN, setModalBCN] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalArticle() {
		setModalArticle(!modalArticle);
	}

	function handleToggleModalBCN() {
		setModalBCN(!modalBCN);
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = normative => {
		setDataNormative(normative);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = normative => {
		setDataNormative(normative);
		handleToggleModal();
	};

	// Article
	const handleClickEdiArticle = normative => {
		setDataNormative(normative);
		handleToggleModalArticle();
	};

	// BCN
	const handleClickEdiBCN = bcn_code => {
		setBCNCode(bcn_code);
		handleToggleModalBCN();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				columnDefType: 'display',
				
				width: 10,
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												title={'Editar'}
												to='#'
												onClick={() => {
													const normativeData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(normativeData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Eliminar'}
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const normativeData = cellProps.row.original;
													handleClickDelete(normativeData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Artículos'}
												to='#'
												onClick={() => {
													const normativeData = cellProps.row.original;
													handleClickEdiArticle(normativeData);
												}}
											>
												<i className='ri-article-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Cargar Ley Chile'}
												to='#'
												onClick={() => {
													handleClickEdiBCN(cellProps.row.original.bcn_code);
													setDataNormative(cellProps.row.original);
												}}
											>
												<i className='ri-download-cloud-2-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Categoría de normativa',
				accessorKey: 'normative_category.name',
				
				width: 10,
			},
			{
				header: 'Número',
				accessorKey: 'number',
				
				width: 10,
			},
			{ header: 'Año', accessorKey: 'year',  width: 10 },
			{
				header: 'Nombre',
				accessorKey: 'name',
				
				width: '30%',
				Cell: ({ row }) => { return <div className='no-nowrap'>{toSmartTitleCase(row.original.name)}</div>; },
			},
			{
				header: 'Enlace',
				accessorKey: 'link',
				
				width: 10,
				Cell: ({ row }) => (
					<a
						href={row.original.link}
						target='_blank'
						rel='noopener noreferrer'
						style={{
							cursor: 'pointer',
							color: 'var(--vz-primary)',
							textDecoration: 'none',
							fontWeight: 'bold',
						}}
					>
						<i className='ri-link'></i> Enlace
					</a>
				),
			},
			{ header: 'BCN', accessorKey: 'bcn_code',  width: 10 },
			{
				header: 'Entidad de normativa',
				
				Cell: ({ row }) => {
					return (
						<div className='no-nowrap'>
							{row.original.normative_entity.map(item => item.name).join('; ')}
						</div>
					);
				},
				width: '15%',
			},
			{
				header: 'Nacional',
				accessorKey: 'national',
				
				width: 10,
				dataType: 'boolean',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='disabled'
							name='disabled'
							disabled
							checked={row.original.national}
						/>
					);
				},
			},
			{
				header: 'Interna',
				accessorKey: 'internal',
				
				width: 10,
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='disabled'
							name='disabled'
							disabled
							checked={row.original.internal}
						/>
					);
				},
			},
			{
				header: 'Estado',
				accessorFn: row => row.normative_status?.name,
				
				size: 'auto',
				Cell: ({ row }) => {
					const { name, bgcolor, txcolor } =
						row.original.normative_status ?? {};

					return (
						<div>
							<span
								className={`badge`}
								style={{ backgroundColor: bgcolor, color: txcolor }}
							>
								{name || ''}
							</span>
						</div>
					);
				},
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataNormative({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Normativa
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={normativeList || []}
								isLoadingData={isLoadingList}
								nameFile={'normativas'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataNormative({});
											handleToggleModal();
										},
										title: 'Crear Normativa'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditNormativeModal
				dataNormative={dataNormative}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
			// activeTab={activeTab}
			// toggleTab={toggleTab}
			/>

			<AddEditArticleModal
				dataNormative={dataNormative}
				isOpen={modalArticle}
				handleToggleModalArticle={handleToggleModalArticle}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<AddEditBCNModal
				bcn_code={bcn_code}
				normative_id={dataNormative._id}
				isOpen={modalBCN}
				handleToggleModalBCN={handleToggleModalBCN}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<DeleteNormativeModal
				dataNormative={dataNormative}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default NormativesList;
